



































































































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreMakeChangesLock from '@/components/shared/MStoreMakeChangesLock.vue';
import { ConfigurationChangeModel, DocumentEncryptionConfigurationModel, DocumentEncryptionStatusModel, StoreConstants } from '@/types';
import { mapActions, mapGetters } from 'vuex';
import { DocumentEncryptionConfigurationService } from '@/services/DocumentEncryptionConfigurationService';
import MStoreAccordion from '@/components/shared/MStoreAccordion.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { ObjectUtils } from '@/utils/objectUtils';
import MStoreCardPanel from '@/components/shared/MStoreCardPanel.vue';
import { FormFieldValidation } from '@/mixins/formValidation';
import { confirmationHelper } from '@/mixins/confirmationHelper';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';

export default Vue.extend({
  name: 'DocumentEncryptionConfiguration',
  mixins: [FormFieldValidation, confirmationHelper],
  data() {
    return {
      isLoading: true,
      documentEncryptionConfiguration: {} as DocumentEncryptionConfigurationModel,
      documentEncryptionConfigurationClone: {} as DocumentEncryptionConfigurationModel,
      isSubmitting: false,
      lockCardTitle: 'Toolkit Lock',
      isStatusLoading: true,
      documentEncryptionStatusModel: { statusColumns: [], statusData: [] } as DocumentEncryptionStatusModel,
      showAllDocumentTypes: false,
      itemsPerPage: 20,
      showSorting: false,
      sortOptions: [],
      filterOptions: [],
      currentPage: 1,
      showFilters: false,
      appliedSortOptions: [],
      appliedFilterOptions: [],
      searchQuery: '',
      sortBy: '',
      sortDesc: false
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChange,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading
    ]),
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    lock(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock];
    },
    bypassLockingOnToolkit(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock];
    },
    isLockLoading(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading];
    },
    filteredItems(this: any) {
      let allItems = this.documentEncryptionStatusModel.statusData;
      if (!this.showAllDocumentTypes) {
        allItems = this.documentEncryptionStatusModel.statusData.filter((x: any) => x.EncryptionEnabled === 'EnabledForNewAndExistingDocuments');
      }

      // hack - trigger filtering in MStoreTable to update pagination
      // tslint:disable no-construct
      this.searchQuery = new String(this.searchQuery);

      return allItems;
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setShowApplicationDirtyModal', 'setApplicationDirty', 'setApplicationDirtyOnModal']),
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [StoreConstants.CabinetConfiguration.Actions.SetCabientConfigurationEnableEncryptionForNewCabinets]),
    ...mapActions(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Actions.BeginChange,
      StoreConstants.ConfigurationChange.Actions.EndChange,
      StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage
    ]),
    async onReleaseLock(this: any) {
      await this[StoreConstants.ConfigurationChange.Actions.EndChange](this.CHANGE_CONTROLLER_PATH);
    },
    async onSubmitAsync(this: any) {
      this.isSubmitting = true;
      try {
        await DocumentEncryptionConfigurationService.updateDocumentEncryptionConfigurationAsync(this.documentEncryptionConfigurationClone as DocumentEncryptionConfigurationModel);
        SnotifyConfiguration.showSuccess('Document Encryption settings updated.');
        await this[StoreConstants.CabinetConfiguration.Actions.SetCabientConfigurationEnableEncryptionForNewCabinets](this.documentEncryptionConfigurationClone.isEncryptionEnabledForNewCabinets);
        this.setApplicationDirty(false);
      } catch (error) {
        this.$log('Error updating document encryption parameters', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async onCancelButtonClicked(this: any, dirty: boolean, reset: () => void) {
      let hasUnsavedChangesToKeep: boolean = false;
      if (dirty) {
        hasUnsavedChangesToKeep = await this.confirmDiscardChangesOnApplicationDirty();
      }
      if (!hasUnsavedChangesToKeep) {
        await this.cloneDocumentEncryptionConfiguration();
        reset();
      }
    },
    async onChangeReasonEntered(this: any, changeReason: string) {
      try {
        await this[StoreConstants.ConfigurationChange.Actions.BeginChange]({
          controllerPath: this.CHANGE_CONTROLLER_PATH,
          configurationChange: {
            description: changeReason
          } as ConfigurationChangeModel
        });
      } catch (error) {
        this.$log(error);
      }
    },
    async cloneDocumentEncryptionConfiguration(this: any) {
      if (!ObjectUtils.isNullOrEmpty(this.documentEncryptionConfiguration)) {
        this.documentEncryptionConfigurationClone = ObjectUtils.deepCloneObject(this.documentEncryptionConfiguration);
      }
    },
    onDirtyForm(this: any, isDirty: boolean) {
      this.setApplicationDirty(isDirty);
    },
    async confirmDiscardChangesOnApplicationDirty(this: any) {
      try {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true);
        if (!hasUnsavedChangesToKeep) {
          this.setApplicationDirty(false);
          this.setApplicationDirtyOnModal(false);
        }
        this.setShowApplicationDirtyModal(false);
        return hasUnsavedChangesToKeep;
      } catch (error) {
        this.$log(error);
      }
    },
    async getDocumentEncryptionStatusAsync() {
      this.isStatusLoading = true;
      this.documentEncryptionStatusModel = await DocumentEncryptionConfigurationService.getDocumentEncryptionStatusAsync();
      this.isStatusLoading = false;
    },
    onShowSorting(this: any) {
      this.showSorting = !this.showSorting;
    },
    onShowFilters(this: any) {
      this.showFilters = !this.showFilters;
    },
    onUpdateCurrentPage(this: any, _: string, value: number) {
      this.currentPage = value;
    },
    onUpdateItemsPerPage(this: any, _: string, value: number) {
      this.itemsPerPage = value;
    },
    onSortingApplied(this: any) {
      this.sortItems();
    },
    async onRefreshClickedAsync(this: any) {
      await this.getDocumentEncryptionStatusAsync();
    }
  },
  async mounted(this: any) {
    this[StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage](this.CHANGE_CONTROLLER_PATH);
    this.documentEncryptionConfiguration = await DocumentEncryptionConfigurationService.getDocumentEncryptionConfigurationAsync();
    this.cloneDocumentEncryptionConfiguration();
    this.isLoading = false;
    this.getDocumentEncryptionStatusAsync();
  },
  created(this: any) {
    this.CHANGE_CONTROLLER_PATH = 'documentEncryptionConfiguration';
  },
  components: {
    LoadingSpinner,
    MStoreMakeChangesLock,
    MStoreAccordion,
    MStoreFormCheckbox,
    MStoreForm,
    MStoreSpinnerButton,
    MStoreCardPanel,
    MStoreTable
  }
});
